import React from "react";
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import AllApps from "./components/AllApps";
import Ending from "./components/Ending";
// import Footer from "./components/Footer";
import Navbar from './components/Navbar';
import Registry from "./components/Registry";
import HomePage from "./pages/HomePage";
import WalletPage from "./pages/WalletPage";


const App = () => {
  return (
    <div className="font-roboto">
      <Router>
  <div className="">
      <Navbar />
  </div>
  <Switch>
    <Route exact path="/" component={HomePage} /> 
     <Route  path="/wallets" component={WalletPage} /> 
     <Route  path="/connect-apps" component={AllApps} /> 
     <Route path="/connect-wallet" component={Registry} />
     <Route path="/error" component={Ending} />
  </Switch>
  {/* <Footer /> */}
</Router>
    </div>
  )
}

export default App;